import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { RankingResultCategoryChoices } from "utils/choices";

const getGroupName = group => RankingResultCategoryChoices.find(choice => choice.id === group)?.name ?? "";

const AdditionalCapacityPreview = ({ specialities, results }) => {
  const getSpecialityName = specialityId =>
    specialities.find(speciality => speciality.id === specialityId)?.name ?? `Специалност ${specialityId}`;

  return (
    <Box>
      <Typography
        variant="body2"
        color="secondary"
        sx={{ fontStyle: "italic", marginBottom: 2 }}
      >
        Поради правилото за равен бал реално приетите кандидати може да са повече от заявените места.
      </Typography>
      {results.map(result => (
        <Box
          key={result.specialityId}
          sx={{ marginBottom: 3 }}
        >
          <Typography
            color="primary"
            sx={{ marginBottom: 1 }}
          >
            {`${getSpecialityName(result.specialityId)} — ${result.newlyAcceptedCandidates?.length ?? 0} новоприети`}
          </Typography>
          {result.newlyAcceptedCandidates?.length ? (
            <TableContainer
              component={Paper}
              sx={{ boxShadow: 3, maxHeight: 320, overflowY: "auto" }}
            >
              <Table
                size="small"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold" }}>Име</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Бал</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Категория</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Желание</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {result.newlyAcceptedCandidates.map(candidate => (
                    <TableRow key={candidate.candidacyId}>
                      <TableCell>{candidate.fullName}</TableCell>
                      <TableCell>{Number(candidate.score).toFixed(2)}</TableCell>
                      <TableCell>{getGroupName(candidate.group)}</TableCell>
                      <TableCell>{candidate.specialityPriorityNumber}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2">Няма кандидати, които биха били приети.</Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default AdditionalCapacityPreview;
